module.exports = __webpack_public_path__ + "05ffad53b0d4a1265a45011817dc38c5.pdf";